import React from 'react';
import { ThemeProvider } from 'styled-components';
import { Col, Skeleton } from 'antd';
import { Typography } from 'antd';
import { useTheme } from '../../../context/ThemeContext';
import { StyledCard, StatsGrid, StatCard, StyledStatistic } from './Styles';
import { addCommasInPrices } from './constants';
import { CustomerStatsSectionProps } from './types';

const { Title } = Typography;

const CustomerStatsSection: React.FC<CustomerStatsSectionProps> = ({
  reportData,
  loading = false,
}) => {
  const { isDarkMode } = useTheme();
  const theme = { mode: (isDarkMode ? 'dark' : 'light') as 'light' | 'dark' };

  if (loading) {
    return (
      <ThemeProvider theme={theme}>
        <StyledCard title={<Title level={4} style={{ margin: 0 }}>Customer Statistics</Title>}>
          <StatsGrid gutter={[16, 16]}>
            {Array.from({ length: 4 }).map((_, index) => (
              <Col xs={24} sm={12} md={6} key={index}>
                <StatCard>
                  <Skeleton active paragraph={{ rows: 1 }} />
                </StatCard>
              </Col>
            ))}
          </StatsGrid>
        </StyledCard>
      </ThemeProvider>
    );
  }

  if (!reportData?.customerStats) {
    return null;
  }

  const customerStats = reportData.customerStats;

  return (
    <ThemeProvider theme={theme}>
      <StyledCard title={<Title level={4} style={{ margin: 0 }}>Customer Statistics</Title>}>
        <StatsGrid gutter={[16, 16]}>
          <Col xs={24} sm={12} md={6}>
            <StatCard>
              <StyledStatistic
                title="Total Customers"
                value={customerStats.totalCustomers || 0}
              />
            </StatCard>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <StatCard>
              <StyledStatistic
                title="New Customers"
                value={customerStats.newCustomers || 0}
              />
            </StatCard>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <StatCard>
              <StyledStatistic
                title="Repeat Customers"
                value={customerStats.repeatCustomers || 0}
              />
            </StatCard>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <StatCard>
              <StyledStatistic
                title="Average Spend"
                value={`$${addCommasInPrices(customerStats.averageSpend || 0)}`}
              />
            </StatCard>
          </Col>
        </StatsGrid>
      </StyledCard>
    </ThemeProvider>
  );
};

export default CustomerStatsSection;
